import { render, staticRenderFns } from "./ViFeatureRequest.vue?vue&type=template&id=679e0bed"
import script from "./ViFeatureRequest.vue?vue&type=script&lang=js"
export * from "./ViFeatureRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports